//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    text: {
      type: String,
      default: '按钮'
    },
    customStyle: {
      type: Object,
      default: function _default() {
        return {
          width: '100%',
          height: '40px'
        };
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit('handleClick');
    }
  }
};